export default __webpack_public_path__ + "static/media/temp-background.c1fcd58c.jpg";